<router-outlet />
<!-- Onboarding desactivado temporalmente. Al reactivarlo, sustituir el flujo directo de Identity. -->
<!-- <app-ambassador-onboarding-flow #onboardingFlow></app-ambassador-onboarding-flow> -->
<app-identity-validation-flow #onboardingFlow></app-identity-validation-flow>

<app-flyer-popup [autoOpen]="false" [autoplay]="true" [autoplayIntervalMs]="8000" [pauseAutoplayOnHover]="false"
  [pauseAutoplayOnFocus]="false" (loadCompleted)="onboardingFlow.onMarketingFlyerLoadCompleted($event)"
  (closed)="onboardingFlow.onMarketingFlyerClosed()">
</app-flyer-popup>

<app-modal-notify *ngIf="notify" [title]="notify.title" [message]="notify.message" [iconType]="notify.type"
  [oneButton]="notify.type !== 'warning'" [primaryText]="notify.type === 'warning' ? 'Eliminar' : 'Entendido'"
  (closed)="closeNotify()" (confirmed)="closeNotify()">
</app-modal-notify>

<app-chat-button *ngIf="showChatButton"></app-chat-button>
